import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import Episode from '../../../domain/entities/Episode';

export default function reducer(
  state: {[key: number]: Episode} = {},
  action: AnyAction,
): {[key: number]: Episode} {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexEpisodesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Episode}, record: Episode) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowEpisodeSuccess:
    case Types.CreateEpisodeSuccess:
    case Types.UpdateEpisodeSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    case Types.DestroyEpisodeSuccess: {
      const deleteState = {...state};
      delete deleteState[action.payload];
      return deleteState;
    }
    default:
      return state;
  }
}
